import React, { useMemo, useState } from 'react'

import { getTranslate } from 'react-localize-redux'
import { connect } from 'react-redux'

import { getInternshipDocuments } from '../../../../utils/api/internship'
import useRequest from '../../../../hooks/useRequest'
import { TYPES } from '../../../../utils/entities/internshipDocument'
import { deleteInternshipDocument } from '../../../../utils/api/internshipDocument'
import { getUser } from '../../../../reducers/UserReducer'
import InternshipFilesTable from './InternshipFilesTable'
import { TableParameters } from '../../../../utils/entities/tableParameters'

const mapStateToProps = state => ({ t: getTranslate(state.locale), user: getUser(state.getUser) })

const InternshipFilesManager = ({ user, internship, readOnly, onFileDelete, t }) => {
  const [parameters, setParameters] = useState(new TableParameters())
  const { data, loading, reload } = useRequest({ request: getInternshipDocuments, parameters: internship })

  const displayedFiles = useMemo(() => data.filter(f => f.type.toLowerCase() !== TYPES.CONVENTION), [data])

  const handleDelete = file => {
    if (!readOnly) {
      deleteInternshipDocument(user, file).then(reload)
    }
  }

  return (
    <InternshipFilesTable
      data={displayedFiles}
      readOnly={readOnly}
      internship={internship}
      loading={loading}
      parameters={parameters}
      onDelete={handleDelete}
      onParametersChange={setParameters}
      reload={reload}
    />
  )
}

export default connect(mapStateToProps)(InternshipFilesManager)
